{
  "de": {
    "installment_term": {
      "actions": {
        "addUnits": "Einheiten",
        "add_fraction": "Anteil hinzufügen",
        "create": "Erstellen",
        "create_and_share": "Erstellen und mit Kunde teilen",
        "create_price_term": "Neue Regel",
        "delete": "Löschen",
        "deleteMultiple": "Löschen …",
        "delete_cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "newInstallment": "Zahlungsplan",
        "only_create": "Nur erstellen",
        "publish_customer": "Für Kunden veröffentlichen",
        "selectAll": "Alle {total} Raten auswählen",
        "selectOne": "Eine Rate auswählen",
        "take": "Übernehmen"
      },
      "attributes": {
        "description": "Beschreibung",
        "installments_count": "{count} Rate | {count} Raten",
        "name": "Titel"
      },
      "labels": {
        "addAllSurcharges": "Alle aktuellen Mehrpreise",
        "addAllUnitsPrices": "Alle Einheitenpreise",
        "allUnitsAssigned": "Alle Einheiten zugewiesen",
        "amount": "Ratenbetrag",
        "balanceFractionTypes": "Anteilarten für den Restbetrag",
        "balanceTotal": "Restbetrag gesamt",
        "containsSurcharges": "Enthält Mehrpreise",
        "create_decision_first": "Diese Option wird verfügbar, sobald Sie eine Entscheidung erstellt haben.",
        "deleteInstallmentTerm": "Zahlungsplan löschen",
        "description": "Beschreibung",
        "documents": "Dokumente",
        "duplicate_price_type": "Für diesen Preistyp existiert bereits ein Anteil.",
        "editInstallmentTerm": "Zahlungsplan bearbeiten",
        "edit_description": "Beschreibung bearbeiten",
        "fixed": "Fest",
        "fixedAmount": "Fester Betrag von",
        "for": "für",
        "forEachUnit": "je Einheit",
        "fraction_types": {
          "absolute": "Fester Betrag",
          "relative": "Prozentsatz"
        },
        "goToAmounts": "Beträge auswählen",
        "installments": "Finanzen",
        "installmentsTitle": "Rate",
        "installments_all_projects": "Finanzen aller Projekte",
        "invalidAmount": "Ungültiger Betrag",
        "list": "Liste",
        "name": "Zahlungsplan #{count}",
        "noContainsSurcharges": "Enthält keine Mehrpreise",
        "noInstallmentsToPay": "Keine ausstehenden Raten",
        "noUnitsClick": "Noch keine Einheiten, hier klicken zum Hinzufügen",
        "ofThe": "von",
        "price_types": {
          "custom_amount": "Sonstiges",
          "price_value": "Gesamtwert",
          "price_value_construction": "Baukosten",
          "price_value_construction_existing": "Kosten des Bestandsbaus",
          "price_value_fees": "Architekten-/Ingenieurhonorare",
          "price_value_land": "Grundstückswert",
          "surcharge": "Mehrpreise",
          "unit": "Einheitenpreise"
        },
        "projectUnitsTotal": "{project_name} hat insgesamt {units_count_max} Einheiten",
        "publish_now": "Jetzt veröffentlichen?",
        "rules": "Zahlungsregeln",
        "rules_subtitle": "Legen Sie fest, welcher Prozentsatz oder Betrag erhoben wird",
        "save_explainer": "Diesen Zahlungsplan für Ihre Kunden sichtbar machen? Oder speichern und später veröffentlichen?",
        "selectUnits": "Einheiten auswählen",
        "selected": "{selected} Rate ausgewählt. | {selected} Raten ausgewählt.",
        "shortcuts": "Schnellzugriff",
        "show_installment_terms_for": "Raten anzeigen für",
        "step1Info": "Beschreibung hinzufügen",
        "step2Subtitle": "Wählen Sie Ihr Projekt aus, um alle Einheiten auf einmal einzubeziehen.",
        "step2Title": "Welche Einheiten gehören zu diesem Zahlungsplan?",
        "surcharges": "Mehrpreise",
        "total": "Gesamt",
        "totalFixed": "Gesamt fest",
        "totalPaid": "Gesamt bezahlt",
        "totalRequested": "Gesamt in Rechnung gestellt",
        "totalSelected": "Alle {total} Raten sind ausgewählt.",
        "totalSurcharges": "Gesamt Mehrpreise",
        "totalUnpaid": "Gesamt unbezahlt",
        "unitSelected": "Noch keine Einheit ausgewählt | Eine Einheit ausgewählt | {count} Einheiten ausgewählt",
        "units": "Einheiten"
      },
      "navigation": {
        "backToInstallmentTerms": "Zurück zur Übersicht der Zahlungspläne"
      },
      "placeholders": {
        "amount": "Wählen Sie einen festen Betrag oder einen Prozentsatz des Einheitenwerts oder der Mehrpreise",
        "description": "Z. B. 10% - Nach dem Gießen der Betonplatte im ersten Stock ...",
        "due_date": "Legen Sie ein Datum fest, bis zu dem die Rate bezahlt werden muss",
        "employees": {
          "new": {
            "subtitle": "Fügen Sie Raten hinzu und behalten Sie deren Status im Blick",
            "title": "Finanzübersicht erstellen"
          }
        },
        "installmentTermFractionNotice": "Die Ratenbeträge können nicht mehr angepasst werden, da einige Raten bereits an den Käufer übermittelt wurden",
        "name": "Z. B. Zahlungsplan #1, Zahlungsplan – Mehrpreise",
        "summary": "Zusammenfassung",
        "surcharge": "Mehrpreis"
      },
      "toasts": {
        "bulk_create": "Rate erfolgreich erstellt | Raten erfolgreich erstellt",
        "bulk_delete": "Rate erfolgreich gelöscht | Raten erfolgreich gelöscht",
        "bulk_update": "Rate erfolgreich aktualisiert | Raten erfolgreich aktualisiert",
        "delete": "Rate erfolgreich gelöscht",
        "update": "Rate erfolgreich aktualisiert"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} wurde bereits mit {fraction_type} in einem anderen bestehenden Zahlungsplan kombiniert. Nur {fraction_type} ist erlaubt, um die Konsistenz zu wahren.",
        "maxLengthName": "Name ist zu lang",
        "needDescription": "Beschreibung erforderlich",
        "needInstallmentTermFraction": "Ein Anteil ist erforderlich",
        "needName": "Name erforderlich",
        "needUniquePricesTypes": "Regeln dürfen innerhalb eines Zahlungsplans nicht denselben Preistyp haben",
        "needValidTerm": "Der Betrag darf nicht 0 sein und der Preistyp muss vorhanden sein",
        "selectInstallmentTerm": "Wählen Sie mindestens 1 Rate aus",
        "selectUnit": "Wählen Sie mindestens 1 Einheit aus"
      }
    }
  }
}
